import axios from 'axios'
import { useLocale } from 'hooks/useLocale'
import type {
  LacedAvailableCurrencies,
  LacedAvailableLocations
} from 'types/localisation'

const useCartCurrencyUpdater = () => {
  const { localiseUrl } = useLocale()

  return async (
    currency: LacedAvailableCurrencies,
    location: LacedAvailableLocations
  ): Promise<void> => {
    const apiCartCurrencyUrl = localiseUrl('/cart/update_currency', {
      localeAsParam: true
    })

    await axios.put(apiCartCurrencyUrl, {
      currency: currency,
      location: location
    })
  }
}

export default useCartCurrencyUpdater
